import * as React from "react";
import Box from "@mui/material/Box";
import { Badge, Stack, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { deCryptFun, enCryptFun } from "./CustomFunction";
import API from "./API";
import { authHeader, getLogUserId } from "./MainFunction";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import { useNavigate } from "react-router";
import { UPDATE_NOTIFICATION_IS_READ } from "../../constants/ApiRoute";
import Popper from "@mui/material/Popper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import NoRecordFound from "./NoRecordFound";
import { getAllNotificationDetails } from "../../redux/action";
import { useDispatch } from "react-redux";
import moment from "moment/moment";
import { useToast } from "./CustomMessages";

export default function NotificationModel(props) {
  const {
    notificationModel1,
    setNotificationModel1,
    notificationDetails,
    filetredNotificationId,
    anchorEl, // This is where the popper will be anchored
    getprojectDetails,
  } = props;
  const today = moment.utc().startOf("day");
  const weekStart = moment().startOf("week");

  console.log(notificationDetails, "notificationDetailsnotificationDetails");

  const [fullWidth] = useState(true);
  const [maxWidth] = useState("sm");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const showToast = useToast();

  // Function to handle closing the popper
  const handleClose = () => {
    setNotificationModel1(false);
  };

  const handelMarkAllAsReadApi = async (readAllClick, notiFIcationID, nt) => {
    console.log(nt, "niiriiiiiiiiiii");
    const obj = {
      userId: getLogUserId(),
      notificationId: readAllClick === "true" ? 0 : notiFIcationID,
      isReadAll: readAllClick === "true" ? 1 : 0,
    };

    const config = {
      method: "PUT",
      url: UPDATE_NOTIFICATION_IS_READ,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(obj)),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      const decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse?.status === "Success") {
        setNotificationModel1(false);
        if (readAllClick === "false") {
          navigate(`/project-details/${nt?.ProjID}`);
        } else {
          showToast(
            "All notifications have been successfully marked as read",
            "success"
          );
        }
        dispatch(getAllNotificationDetails());
      }

      return parsedResponse;
    } catch (error) {
      if (error.response) {
        const decryptedError = deCryptFun(error.response.data);
        return JSON.parse(decryptedError);
      }
      throw error;
    }
  };

  const formatRelativeTime = (timestamp) => {
    const now = moment.utc();
    const lastUpdated = moment.utc(timestamp);

    const duration = moment.duration(now.diff(lastUpdated));
    const daysAgo = Math.max(Math.floor(duration.asDays()), 0); // Prevent negative values
    const hoursAgo = Math.max(Math.floor(duration.asHours()), 0);
    const minutesAgo = Math.max(Math.floor(duration.asMinutes()), 0);

    if (daysAgo >= 1 && daysAgo <= 7) {
      return `${daysAgo} day${daysAgo > 1 ? "s" : ""} ago`;
    } else if (daysAgo > 7) {
      return `${daysAgo} day${daysAgo > 1 ? "s" : ""} ago`;
    } else if (hoursAgo >= 1) {
      return `${hoursAgo} hour${hoursAgo > 1 ? "s" : ""} ago`;
    } else {
      return minutesAgo === 0
        ? "Just now"
        : `${minutesAgo} minute${minutesAgo > 1 ? "s" : ""} ago`;
    }
  };

  const NotificationLayout = ({ nt }) => (
    <Stack
      className={nt.IsRead ? "noti-row noti-read" : "noti-row noti-unread"}
      sx={{
        padding: "10px 16px",
        borderBottom: "1px solid #E6E9EF",
        backgroundColor: nt.IsRead ? "#F9F9F9" : "#FFFFFF",
        display: "flex !important",
        justifyContent: "space-between",
      }}
    >
      <Box
        display="flex"
        alignItems="baseline"
        columnGap="10px"
        sx={{ cursor: "pointer" }}
        onClick={() => {
          handelMarkAllAsReadApi("false", nt?.NotificationID, nt);
        }}
      >
        <Box
          className={
            nt.isRead
              ? "circle-bg circle-bg-read"
              : "circle-bg circle-bg-unread"
          }
          sx={{
            width: "8px",
            height: "8px",
            minWidth: "8px",
            borderRadius: "50%",
            backgroundColor: nt.IsRead ? "#ccc" : "#007BFF",
            visibility: nt.IsRead ? "hidden" : "unset",
          }}
        ></Box>
        <Box>
          <Typography
            sx={{ color: "#212121 !important" }}
            variant="h6"
            fontWeight="bold"
            fontSize="13px"
          >
            {nt?.Title || ""}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {nt?.Description || ""}
          </Typography>
          <Typography
            sx={{ color: "#212121 !important" }}
            variant="h6"
            fontWeight="bold"
            fontSize="13px"
          >
            {nt?.LastUpdated ? formatRelativeTime(nt.LastUpdated) : ""}
          </Typography>
        </Box>
      </Box>
      {/* <ArrowRightAltOutlinedIcon
        sx={{ color: "gray" }}
        onClick={() => {
          navigate(`/project-details/${nt?.ProjID}`);
          setNotificationModel1(false);
        }}
      /> */}
    </Stack>
  );

  // Filter "Today" notifications
  // Notifications from today
  const todayNotifications = notificationDetails.filter((nt) => {
    const lastUpdated = moment.utc(nt.LastUpdated);
    const now = moment.utc();
    return now.diff(lastUpdated, "days") === 0; // Less than 1 day old
  });

  // Notifications from this week
  const thisWeekNotifications = notificationDetails.filter((nt) => {
    const lastUpdated = moment.utc(nt.LastUpdated);
    const now = moment.utc();
    const diffDays = now.diff(lastUpdated, "days");
    return diffDays >= 1 && diffDays <= 7; // Between 1 and 7 days old
  });

  // Older notifications
  const olderNotifications = notificationDetails.filter((nt) => {
    const lastUpdated = moment.utc(nt.LastUpdated);
    const now = moment.utc();
    return now.diff(lastUpdated, "days") >= 8; // 8 days or older
  });

  console.log("Today:", todayNotifications.length);
  console.log("This Week:", thisWeekNotifications.length);
  console.log("Older:", olderNotifications.length);

  todayNotifications.forEach((nt) =>
    console.log(
      `Today - Notification: ${nt.NotificationID}, Days: ${moment
        .utc()
        .diff(moment.utc(nt.LastUpdated), "days")}`
    )
  );

  thisWeekNotifications.forEach((nt) =>
    console.log(
      `This Week - Notification: ${nt.NotificationID}, Days: ${moment
        .utc()
        .diff(moment.utc(nt.LastUpdated), "days")}`
    )
  );

  olderNotifications.forEach((nt) =>
    console.log(
      `Older - Notification: ${nt.NotificationID}, Days: ${moment
        .utc()
        .diff(moment.utc(nt.LastUpdated), "days")}`
    )
  );

  const sortNotificationsByDate = (notifications) =>
    notifications.sort(
      (a, b) =>
        moment.utc(b.LastUpdated).valueOf() -
        moment.utc(a.LastUpdated).valueOf()
    );

  const sortedTodayNotifications = sortNotificationsByDate(todayNotifications);
  const sortedThisWeekNotifications = sortNotificationsByDate(
    thisWeekNotifications
  );
  const sortedOlderNotifications = sortNotificationsByDate(olderNotifications);

  console.log(
    sortedTodayNotifications,
    "sortedTodayNotificationssortedTodayNotifications",
    sortedThisWeekNotifications,
    sortedOlderNotifications
  );

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Popper
        open={notificationModel1}
        className="popper-box"
        anchorEl={anchorEl}
        placement="right" // Position the popper to the top-right
        sx={{
          zIndex: 1300, // Ensure it's above other content
          width: "40%",
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: "0px 2px 10px rgba(0,0,0,0.2)",
            maxHeight: "87%",
            overflowY: "auto",

            width: "100%",
          }}
        >
          <Stack
            sx={{ padding: "16px" }}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              sx={{ color: "#000 !important" }}
              className="noti-title"
              variant="h5"
            >
              Notifications
            </Typography>
            {filetredNotificationId?.length === 0 ? (
              // <Typography
              //   variant="h6"
              //   className="Unmark-read"
              //   sx={{ cursor: "none", color: "#B0B0B0" }}
              // >
              //   Mark all as read
              // </Typography>
              ""
            ) : (
              <Typography
                variant="h6"
                className="mark-read"
                sx={{ cursor: "pointer", color: "#007BFF" }}
                onClick={() => handelMarkAllAsReadApi("true")}
              >
                Mark all as read
              </Typography>
            )}
          </Stack>

          <Box
            sx={{
              maxHeight: "72vh",
              overflowY: "auto",
              paddingTop: "0px",
              borderTop: "2px solid #ededed",
            }}
          >
            {notificationDetails?.length > 0 ? (
              <>
                {/* Filter and display "Today" notifications */}
                {sortedTodayNotifications?.length > 0 && (
                  <Box>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      sx={{
                        padding: "6px 16px",
                        fontSize: "16px !important",
                        pl: "34px",
                        border: "1px solid #f6f7f9",
                        color: "#212121 !important",
                      }}
                    >
                      Today
                    </Typography>
                    {sortedTodayNotifications.map((nt) => (
                      <NotificationLayout key={nt.NotificationID} nt={nt} />
                    ))}
                  </Box>
                )}

                {sortedThisWeekNotifications?.length > 0 && (
                  <Box>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      sx={{
                        padding: "6px 16px",
                        fontSize: "16px !important",
                        pl: "34px",
                        color: "#212121 !important",
                        border: "1px solid #f6f7f9",
                      }}
                    >
                      This Week
                    </Typography>
                    {sortedThisWeekNotifications.map((nt) => (
                      <NotificationLayout key={nt.NotificationID} nt={nt} />
                    ))}
                  </Box>
                )}

                {sortedOlderNotifications?.length > 0 && (
                  <Box>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      sx={{
                        padding: "6px 16px",
                        fontSize: "16px !important",
                        pl: "34px",
                        color: "#212121 !important",
                        border: "1px solid #f6f7f9",
                      }}
                    >
                      Older
                    </Typography>
                    {sortedOlderNotifications.map((nt) => (
                      <NotificationLayout key={nt.NotificationID} nt={nt} />
                    ))}
                  </Box>
                )}
              </>
            ) : (
              <NoRecordFound />
            )}
          </Box>
        </Box>
      </Popper>
    </ClickAwayListener>
  );
}
